// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3H6JG","large":"styles_large__3ZIUa"};